import { render, staticRenderFns } from "./SubProductsOverlay.vue?vue&type=template&id=349cdb8e&scoped=true"
import script from "./SubProductsOverlay.vue?vue&type=script&lang=js"
export * from "./SubProductsOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cdb8e",
  null
  
)

export default component.exports